/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban_boards', { accountScoped: true });
  }

  // Stages (nested under a board)
  getStages(boardId) {
    return axios.get(`${this.url}/${boardId}/kanban_stages`);
  }

  createStage(boardId, stage) {
    return axios.post(`${this.url}/${boardId}/kanban_stages`, {
      kanban_stage: stage,
    });
  }

  updateStage(boardId, stageId, stage) {
    return axios.patch(`${this.url}/${boardId}/kanban_stages/${stageId}`, {
      kanban_stage: stage,
    });
  }

  deleteStage(boardId, stageId) {
    return axios.delete(`${this.url}/${boardId}/kanban_stages/${stageId}`);
  }

  reorderStages(boardId, stageIds) {
    return axios.post(`${this.url}/${boardId}/kanban_stages/reorder`, {
      stage_ids: stageIds,
    });
  }

  // Items (contact cards, nested under a board)
  getItems(boardId) {
    return axios.get(`${this.url}/${boardId}/kanban_items`);
  }

  // Add-or-move: posting an existing contact moves the card (idempotent)
  addItem(boardId, item) {
    return axios.post(`${this.url}/${boardId}/kanban_items`, {
      kanban_item: item,
    });
  }

  // Drag-and-drop persistence endpoint
  moveItem(boardId, itemId, { kanbanStageId, position }) {
    return axios.patch(`${this.url}/${boardId}/kanban_items/${itemId}`, {
      kanban_item: {
        kanban_stage_id: kanbanStageId,
        position,
      },
    });
  }

  deleteItem(boardId, itemId) {
    return axios.delete(`${this.url}/${boardId}/kanban_items/${itemId}`);
  }

  // Kanban memberships for a given contact (across all boards)
  getContactItems(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/kanban_items`);
  }
}

export default new KanbanAPI();
